import React from 'react'
import cloneDeep from 'lodash/cloneDeep'
import { IPriceRequestDetailsFragment } from 'apps/marketplace/pages/spot-quote-tool/graphql/PriceRequestDetailsFragment'
import { RequestedByAvatar } from 'apps/marketplace/pages/spot-quote-tool/historical-quotes/components/RequestedByAvatar'
import { SubmittedQuoteCell } from 'apps/marketplace/pages/spot-quote-tool/historical-quotes/components/SubmittedQuoteCell'
import { IQuoteUpdate } from 'apps/marketplace/pages/spot-quote-tool/historical-quotes/types'
import { checkIfMostRecentQuotePresent } from 'apps/marketplace/pages/spot-quote-tool/historical-quotes/utils/formatFocusPanelContents'
import { formatCreatedAtTime } from 'apps/marketplace/pages/spot-quote-tool/historical-quotes/utils/formatHistoricalQuotesTableContents'
import { TableHead, TableCell, TableRow, Table, TableBody, InlineMessage } from 'transfix-ui'

export interface IQuoteChangesProps {
  quoteUpdates: IQuoteUpdate[] | null
  priceRequest: IPriceRequestDetailsFragment
}

export const QuoteChanges = ({ priceRequest, quoteUpdates }: IQuoteChangesProps) => {
  if (quoteUpdates === null && !priceRequest.customerQuote) {
    return <div>Error getting quote updates, please contact FA engineering</div>
  }

  // avoid messing with the state variable
  const quotes = quoteUpdates === null ? [] : cloneDeep(quoteUpdates)

  if (quotes.length === 0 && !priceRequest.customerQuote) {
    return <div>No Quotes Submitted</div>
  }

  const isMostRecentQuotePresent = checkIfMostRecentQuotePresent(quotes, priceRequest)

  return (
    <div>
      {!isMostRecentQuotePresent && (
        <InlineMessage
          dataTest='missing-most-recent'
          message='Most recent quote not yet available... Please check back in 10 mins.'
        />
      )}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Update</TableCell>
            <TableCell>Quote</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {quotes.map(quote => {
            return (
              <TableRow dataTest={`quote-history-${quote.id}`} key={`quote-history-${quote.id}`}>
                <TableCell>
                  <RequestedByAvatar fullName={quote.author} userType={quote.userType} />
                  {formatCreatedAtTime(quote.occurredAt)}
                </TableCell>
                <TableCell>
                  <SubmittedQuoteCell
                    customerQuote={quote.customerQuote}
                    numberOfDecimals={2}
                    customerQuoteType={quote.customerQuoteType}
                    allInQuote={priceRequest.premiums?.quoteWithFuel}
                    linehaulQuote={priceRequest.premiums?.quoteWithoutFuel}
                  />
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </div>
  )
}
